var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconQuoteGradient = function SvgIconQuoteGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 18,
    fill: "none",
    viewBox: "0 0 27 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_5966_559)",
    fillRule: "evenodd",
    d: "M24.176 1.963A.821.821 0 0 0 24.24.605a.812.812 0 0 0-.728-.125c-.621.193-2.892.973-5.023 2.685-2.145 1.723-4.19 4.432-4.19 8.435 0 3.532 2.405 6.4 5.6 6.4h.8a5.6 5.6 0 0 0 .829-11.14c.26-3.278 2.204-4.628 2.647-4.897Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_5966_559)",
    fillRule: "evenodd",
    d: "M10.576 1.883A.821.821 0 0 0 10.64.525.812.812 0 0 0 9.913.4c-.621.193-2.892.973-5.023 2.685C2.745 4.808.7 7.517.7 11.519c0 3.533 2.405 6.4 5.6 6.4h.8A5.6 5.6 0 0 0 7.93 6.78c.26-3.278 2.204-4.628 2.647-4.897Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5966_559",
    x1: -2.5,
    x2: 31.706,
    y1: 1.201,
    y2: -2.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5993EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5966_559",
    x1: -2.5,
    x2: 31.706,
    y1: 1.201,
    y2: -2.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5993EA"
  })))));
};
export default SvgIconQuoteGradient;